/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Full_Notice_DescriptionInputs */



/**
* | output |
* | --- |
* | "Complete terms and conditions for the Guardrails feature" |
*
* @param {Guardrails_Full_Notice_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_full_notice_description = /** @type {((inputs?: Guardrails_Full_Notice_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Full_Notice_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständige Nutzungsbedingungen für die Guardrails-Funktion")
	return /** @type {LocalizedString} */ ("Complete terms and conditions for the Guardrails feature")
});